import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { RenderTextField as TextField } from '../../../components/RenderTextField';
import { RenderMarkupEditor as MarkupEditor } from '../../../components/MarkupEditor';
import { validateForm } from '../../../utils';
import { WebsitesEditStepActions } from './WebsitesEditStepActions';
import styles from './WebsiteEditStepStyles';
import LeavePrompt from '../../../components/LeavePrompt';
import TemplatesSelectionDialog from '../../../components/TemplatesSelectionDialog';

const CHECK_BOX_TEMPLATE = 'choiceBoxTemplate';

const validate = values => {
  const requiredFields = [];
  return validateForm(values, requiredFields);
};

class Form extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      templateName: props.initialValues.choiceBoxTemplate.name
    };
  }

  changeTemplateName = (changedTemplateName) => {
    changedTemplateName.split(this.props.initialValues.websiteName).join('');

    this.setState({
      templateName: `${this.props.initialValues.websiteName} - ${changedTemplateName}`,
    });
  };

  getFormFieldName(propertyName) {
    return `${CHECK_BOX_TEMPLATE}.${propertyName}`
  }

  changeTemplate(args, formState, tools) {
    const template = args[0];
    for (const property in template) {
      tools.changeValue(formState, this.getFormFieldName(property), () => template[property]);
    }
  }

  render () {
    const { classes, onSubmit, initialValues, id } = this.props;

    return (
      <div className={classes.container}>
        <LeavePrompt dirty={this.props.dirty && !this.props.submitting}
                     message={'You have unsaved data. Do you want to leave anyway?'}/>
        <FinalForm
        onSubmit={(data) => {
          onSubmit(data)
        }}
        initialValues={initialValues}
        validate={validate}
        mutators={{changeTemplate: this.changeTemplate.bind(this)}}
        render={({ handleSubmit, form: finalForm, invalid }) => {
          return (
            <form onSubmit={handleSubmit}>
              <WebsitesEditStepActions
                id={id}
                title="Privacy Controls"
                disabled={invalid}
              />
              <div className={classes.wrapper}>
                <div>
                  <Typography className={classes.heading}>Privacy Controls</Typography>
                  <div className={classes.template}>
                    <Typography variant='caption'>Design</Typography>
                    <Typography variant='body1'>{this.state.templateName}</Typography>
                    <TemplatesSelectionDialog style={classes.changeTemplateButton}
                                              callbackFromParent={this.changeTemplateName}
                                              website={id}
                                              templatesType='choice_box_templates'
                                              formName='choice-box'
                                              selectedTemplates={{ choiceBoxTemplate: initialValues.choiceBoxTemplate }}
                                              onSubmit={finalForm.mutators.changeTemplate}
                                              />
                  </div>
                </div>
                <div role="panel">
                  <ExpansionPanel elevation={2} defaultExpanded>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography>Translations</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.extendedDetails}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Field component={TextField}
                                 className={classes.textField}
                                 name="cookieConsentText.categoryConsentHeader"
                                 label="Privacy Controls header"
                                 margin="normal"/>
                        </Grid>
                        <Grid item xs={6}>
                          <Field component={TextField}
                                 className={classes.textField}
                                 name="cookieConsentText.multiaccept"
                                 label="Multi accept button text"
                                 margin="normal"/>
                        </Grid>
                        <Grid item xs={6}>
                          <Field component={TextField}
                                 className={classes.textField}
                                 name="cookieConsentText.multidecline"
                                 label="Multi decline button text"
                                 margin="normal"/>
                        </Grid>
                        <Grid item xs={6}>
                          <Field component={TextField}
                                 className={classes.textField}
                                 name="cookieConsentText.updateConsentButton"
                                 label="Save current settings button text"
                                 margin="normal"/>
                        </Grid>
                      </Grid>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </div>
                <div role="panel">
                  <ExpansionPanel elevation={2}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                      <Typography> Advanced Settings </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.extendedDetails}>
                      <Typography className={classes.extendedDetailsDescription}>
                        Customize the way your Privacy Controls looks and functions
                      </Typography>
                      <Field component={MarkupEditor}
                             className={classes.textField}
                             name="choiceBoxTemplate.html"
                             label="HTML definition of Privacy Controls"
                             mode="html"/>
                      <Field component={MarkupEditor}
                             className={classes.textField}
                             name="choiceBoxTemplate.css"
                             label="Cascading Style Sheets (CSS)"
                             mode="css"/>
                      <Field component={MarkupEditor}
                             className={classes.textField}
                             name="choiceBoxTemplate.js"
                             label="Javascript functions"
                             mode="javascript"/>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </div>
              </div>
            </form>
            )}}
        />
      </div>
    );
  }
}

const StyledForm = withStyles(styles)(Form);
export default StyledForm;

